import { render, staticRenderFns } from "./ClassicSubtabButton.vue?vue&type=template&id=6b211a03&scoped=true"
import script from "./ClassicSubtabButton.vue?vue&type=script&lang=js"
export * from "./ClassicSubtabButton.vue?vue&type=script&lang=js"
import style0 from "./ClassicSubtabButton.vue?vue&type=style&index=0&id=6b211a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b211a03",
  null
  
)

export default component.exports